import './Badge.css'
import cx from 'classnames'

type size =
  | 'xs'
  | 'sm'
  | 'md'

type variant =
  | 'blue'
  | 'yellow'
  | 'green'
  | 'red'
  | 'blue-stroke'
  | 'yellow-stroke'
  | 'green-stroke'
  | 'red-stroke'

const sizeClasses: Record<size, string> = {
  xs: 'badge-xs',
  sm: 'badge-sm', 
  md: 'badge-md'
}

const variantClasses: Record<variant, string> = {
  blue: 'badge-blue',
  yellow: 'badge-yellow',
  green: 'badge-green',
  red: 'badge-red',
  'blue-stroke': 'badge-blue-stroke',
  'yellow-stroke': 'badge-yellow-stroke',
  'green-stroke': 'badge-green-stroke',
  'red-stroke': 'badge-red-stroke'
}

export function Badge({
  variant,
  size = 'sm',
  children,
  className
}: {
  variant: variant
  size?: size
  children: React.ReactNode
  className?: string
}) {
  return <div className={cx('badge-base', variantClasses[variant], sizeClasses[size], className)}>{children}</div>
}
